import * as yup from 'yup';
import { genericStoreFactory } from '@/utils/genericStoreFactory/genericStoreFactory';
import { providentContractBaseSchema } from '@/features/Contract/Provident/contractBaseSchema';

export const contractSchema = providentContractBaseSchema;

export type ContractStore = yup.Asserts<typeof contractSchema>;

export const useBuContractStore = genericStoreFactory(
  () => providentContractBaseSchema.getDefault(),
  'BuContractStore',
);
